module.exports = __webpack_public_path__ + "c88216c91c78258a39896a2e1eeaa99b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/motorcycle-jacket.png
// module id = 1316
// module chunks = 0